export interface RecipeComposition {
  ingredients?: readonly unknown[] | null;
  parent_recipes?: readonly unknown[] | null;
  parent_recipe_ids?: readonly unknown[] | null;
}

export function hasRecipeComposition(recipe: RecipeComposition): boolean {
  return (recipe.ingredients?.length ?? 0) > 0
    || (recipe.parent_recipes?.length ?? 0) > 0
    || (recipe.parent_recipe_ids?.length ?? 0) > 0;
}
